import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    darkTheme: false,
    layout: 'default',
    user: null,
    pastQuestionId: null,
    uploadDialog: false
  },
  mutations: {
    setLayout(state, layout) {
      state.layout = layout;
    },
    setUser(state, u) {
      state.user = u;
    },
    logout(state) {
      state.loginDialog = true;
      Vue.prototype.$resetAxios();
      state.user = null;
    },
    toggleTheme(state) {
      state.darkTheme = !state.darkTheme;
    },
    setUploadDialogState(state, val) {
      state.uploadDialog = val;
    }
  },
  actions: {
  },
  modules: {
  }
})
